import { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import cx from 'classnames';
import { TIconSizes, Icon, TIcon, Text } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface ISidebarItem {
  className?: string;
  children?: ReactNode;
  to: string | string[]; // support multiple paths
  icon: TIcon;
  id?: string;
  collapsed?: boolean;
  size?: TIconSizes;
}

const Item = ({ className, children, to, icon, id, collapsed, size }: ISidebarItem) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const paths = Array.isArray(to) ? to : [to];

  const isActive = paths.some((path) => currentPath.startsWith(path));
  const linkClass = cx(
    {
      [s.itemActive]: isActive,
      [s.itemCollapsed]: collapsed,
    },
    className,
    s.item,
  );

  const mainTo = Array.isArray(to) ? to[0] : to;

  return (
    <NavLink to={mainTo} className={linkClass} id={id}>
      <div className={s.itemContent}>
        <Icon icon={icon} size={size} />
        {children && (
          <Text className={s.itemContentName} size={Text.size.s} color={Text.color.simpleWhite}>
            {children}
          </Text>
        )}
      </div>
    </NavLink>
  );
};

export { Item };
